import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import StatusContainer from "../../../../components/_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWrapperSection from "../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import { setHideBreadCrumb } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import { disableSwitcher } from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import globalText from "../../../../utils/globalText";

const InternalTransactionFailed = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const internalError = JSON.parse(sessionStorage.getItem("internalRejected"));

  const extractErrorMessages = (errors) => {
    const messages = [];

    const recurse = (value) => {
      if (Array.isArray(value)) {
        value.forEach(recurse);
      } else if (typeof value === "object" && value !== null) {
        Object.values(value).forEach(recurse);
      } else if (typeof value === "string") {
        messages.push(value);
      }
    };

    recurse(errors);
    return messages;
  };

  const errorMessages = internalError
    ? extractErrorMessages(internalError)
    : [];

  const buttonRows = [
    [
      {
        btnText: globalText?.CREATE_TRANSACTION,
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--negative-bg)",
        icon: ICONS?.ADD_BUTTON_WHITE,
        imgColor: "var(--negative-bg)",
        handleFunction: () =>
          navigate(
            "/internal_transaction_dashboard/create_internal_transaction",
          ),
        fullWidthRequired: true,
        hoverOption: "dark",
      },
    ],
    [
      {
        btnText: globalText?.GO_TO_DASHBOARD,
        enabledBgColor: "var(--negative-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: () => navigate("/internal_transaction_dashboard"),
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];

  useEffect(() => {
    dispatch(disableSwitcher());
    dispatch(setHideBreadCrumb({ hide: true }));
    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  return (
    <StatusContainer
      status="error"
      title={globalText?.TRANSACTION_FAILED}
      buttonRows={buttonRows}
    >
      <TabsWrapperSection title="Error details">
        <div className="flex flex-col">
          {errorMessages.length > GlobalConfiguration?.lengthCheckZero &&
            errorMessages.map((msg, index) => (
              <InfoCard
                key={index}
                bgColor="var(--negative-card)"
                rows={[
                  {
                    leftTitle: msg,
                    leftSubTitle: "Error message",
                  },
                ]}
              />
            ))}
        </div>
      </TabsWrapperSection>
    </StatusContainer>
  );
};

export default InternalTransactionFailed;
